import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import IframeView from "@/components/public/IframeView";
export default {
  name: "ApprovalLaunch",
  components: {
    IframeView: IframeView
  },
  props: ["process-def-id", "process-version-id"],
  data: function data() {
    return {
      loading: false,
      list: [],
      pageNum: 1,
      pageSize: 20,
      total: 0,
      hasContent: false
    };
  },
  computed: _objectSpread({}, mapGetters(["userToken"])),
  created: function created() {
    if (this.userToken) {
      this.initPage();
    }
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    fetchList: function fetchList() {
      var _this = this;

      var obj = {};
      obj.pageNum = this.pageNum;
      obj.pageSize = this.pageSize;
      this.loading = true;
      this.$http.post("/serveCenter/hasLaunchTask", this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        processDefVerId: this.processVersionId
      })).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == 0) {
          _this.list = data.resData.list;
          _this.total = data.resData.total;
          _this.hasContent = _this.list.length && _this.list[0].content ? true : false;
        }

        _this.$nextTick(function () {
          _this.loading = false;
        });
      }).catch(function () {
        _this.loading = false;
      });
    },
    initPage: function initPage() {
      this.pageNum = 1;
      this.fetchList();
    },
    changeSize: function changeSize(value) {
      this.pageSize = value;
      this.fetchList();
    },
    changePage: function changePage(value) {
      this.pageNum = value;
      this.fetchList();
    },
    clickRow: function clickRow(item) {
      this.list[item.index].hasRead = true;
      this.$refs.iframeView.showView(item.taskUrl, item.taskInstId);
    },
    hasRead: function hasRead(_ref2) {
      var row = _ref2.row,
          rowIndex = _ref2.rowIndex;
      row.index = rowIndex;

      if (row.hasRead) {
        return "cu-p";
      }

      return "bold cu-p";
    }
  },
  watch: {},
  filters: {}
};